var map = {
	"./Edukos.png": 191,
	"./MazeRunnerPicture.png": 736,
	"./aashvi.webp": 971,
	"./asfalisLogo.png": 467,
	"./barbiebook.png": 788,
	"./calculator.png": 845,
	"./earth.jpeg": 193,
	"./eggclicker.png": 897,
	"./gps.png": 986,
	"./lifestyle.jpeg": 554,
	"./linkedinpfp.jpeg": 455,
	"./marvel.png": 707,
	"./minesweeper.png": 804,
	"./pennos.png": 14,
	"./pickuplines.png": 330,
	"./profile.png": 437,
	"./restaurantMap.jpg": 221,
	"./secc.png": 694,
	"./segmentation.png": 657,
	"./sms.png": 798,
	"./socialnetwork.jpeg": 339,
	"./ted.png": 97,
	"./waterfall.heic": 659,
	"./weatherapp.jpg": 352
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 925;